// The signed-in staff member, for every screen inside the console shell.
//
// The console layout route (console-routes.tsx) runs the session guard ONCE
// and provides its answer here, so a screen reads `useConsoleMe()` instead of
// probing `GET /v1/platform/me` again. It throws outside the layout, because a
// screen rendered without the guard has no staff member to read.

import { createContext, useContext, type ReactNode } from "react";
import type { PlatformMe } from "../lib/platform-api";

const ConsoleMeContext = createContext<PlatformMe | null>(null);

export function ConsoleMeProvider({ me, children }: { me: PlatformMe; children: ReactNode }) {
  return <ConsoleMeContext.Provider value={me}>{children}</ConsoleMeContext.Provider>;
}

export function useConsoleMe(): PlatformMe {
  const me = useContext(ConsoleMeContext);
  if (me === null) {
    throw new Error("useConsoleMe() outside the console layout: no guard has run");
  }
  return me;
}
